// convert request errors specific to a request library (example: axios) to a common contract, 
//    so that everything above the request agent is unaware of error differences between request libraries
class BizApiErrorConverterStrategyInterface {
    /*
        param   error  the request error
        
        returns {
            _http_status: "string",
            code: "string",
            context_code: "string",
            is_error: true
        }
    */
    convert = (error) => {
        throw new Error("convert method not implemented")
    }
}

export default BizApiErrorConverterStrategyInterface;